var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRerun = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin/Other",
    transform: "translate(-1260.000000, -9.000000)",
    fill: "#335498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rec/Summary-View-Table"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1276.88102,16.4929083 C1276.82355,16.1475556 1276.48492,15.9122868 1276.12469,15.9673844 C1275.76446,16.0224821 1275.51906,16.3471315 1275.57653,16.6924842 C1275.57715,16.6962687 1275.5778,16.7000161 1275.5785,16.7037635 C1276.25112,20.499787 1273.58656,24.0997964 1269.62701,24.7446429 C1265.66747,25.3894894 1261.91238,22.8349623 1261.23976,19.0389388 C1260.56713,15.2429153 1263.23174,11.6429059 1267.19124,10.9980594 C1269.62628,10.6015048 1272.10481,11.4169499 1273.77271,13.1634153 L1270.84671,14.0980346 C1270.50057,14.2084525 1270.31338,14.5669396 1270.42851,14.898787 C1270.42855,14.8988612 1270.42859,14.8989725 1270.42863,14.8990467 C1270.5438,15.230894 1270.91773,15.4103602 1271.26387,15.2999794 C1271.26399,15.2999423 1271.26407,15.2999052 1271.26414,15.2999052 L1275.22713,14.0334757 C1275.49696,13.947323 1275.67897,13.7052273 1275.67893,13.4325589 L1275.67893,9.63323331 C1275.67893,9.28350241 1275.38321,9 1275.01842,9 C1274.65362,9 1274.35791,9.28350241 1274.35791,9.63323331 L1274.35791,11.9463696 C1270.95639,8.84472483 1265.57621,8.97395384 1262.34096,12.2349922 C1259.1057,15.4960306 1259.24046,20.6540233 1262.64201,23.7557051 C1266.04356,26.857387 1271.42371,26.728158 1274.659,23.4670825 C1276.50384,21.6074907 1277.32717,19.0233928 1276.88102,16.4929083 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRerun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Rerun.f06b82a8.svg";
export { ForwardRef as ReactComponent };